import services from "./services"
import search from './search/search.vue'
import followUpDialog from 'follow-up-dialog';
import Uploader from 'uploader';
import schoolDetails from '../components/schoolDetails.vue';
import areaSelect from 'area-select';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import official from '../components/official/index.vue';

export default {
    mixins: [services],
    components: { official, search, 'follow-up-dialog': followUpDialog, schoolDetails, 'area-select': areaSelect },
    data() {
        return {
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            searchVisiable: false,
            query: {},
            childrenId: "",
            /* 跟进情况列表 */
            followUpListVisiable: false,
            followUpList: [], //列表数据
            followUpTotalSize: 0, //列表总条数
            currentId: null,
            followItem: {},
            /* 转正*/
            areaInfo: {
                Provinces_Id: '',
                City_Id: '',
                Area_Id: ''
            },
            dialogVisible: false, //转正
            form: this.initFormData(),
            uploadSwitch: true,
            SchoolPic: [],
            PermitPic: [],
            contractPic: [],
            equipmentPic: [],
            PictureVisible: false,
            SchoolStatus: "", //学校状态，根据该字段判断是否调用转正接口
            //表单验证
            rules: {
                Consignee: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                ],
                ConsigneeTel: [
                    { required: true, message: '请填写活动形式', trigger: 'blur' }
                ],
                ConsigneeAdress: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        initFormData() {
            return cloneDeep({
                "Id": 0,
                "hnd_CooperationPics": "", //合作协议
                "hnd_EquipPics": "", //设备照片
                "Tel": "", //园长电话
                "hnc_drawing": "", //园所照片
                "hndbond_drawing": "", //办园许可证
                "Email": "",
                "QQ": "",
                "Weixin": "",
                "PrincipalName": "", //园长名称
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeProvince": 0,
                "ConsigneeCity": 0,
                "ConsigneeArea": 0,
                "ConsigneeAdress": ""
            });
        },
        handleview(item) {
            this.$refs.schoolDetails.show({
                Id: item.Id,
                isReadonly: true
            });
        },
        /*转正*/
        Regularization(val) {
            this.childrenId = val;
            this.$nextTick(function() {
                this.$refs.myofficial.Regularization({
                    id: val
                });
            });
        },
        /*删除 */
        handleSelectionChange(val) {
            this.sels = val;
        },
        handledel() {
            var ids = this.sels.map(item => item.Id).toString();
            var Params = { "Ids": ids }
            if (ids == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择删除内容',
                    type: 'warning'
                })
            } else {
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.DeleteItem(Params)
                })
            }
        },
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.getList();
        }, //分页选定行
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.getList();
        }, //分页监听dd页面
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        getQueryList(val) {
            this.query = val;
            this.getList();
        },
        //打开跟进情况列表
        checkFollowUpList(id) {
            this.getFollowList({ id: id }); //跟进情况列表
            this.followUpListVisiable = true;
            this.currentId = id;
        },
        //更新跟进情况列表
        refreshFollowUpList(type, val) {
            let options = {
                id: this.currentId
            };
            options[type] = val;
            this.getFollowList(options);
        },
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/reportSchool/vm.js